// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qIVSIfDOPnIPBG242qWi {
  position: absolute;
  top: 30px;
  min-width: 30px;
  right: 0;
  font-family: 'Futura PT Cond';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px;
  line-height: 0.7em;
  background: linear-gradient(180deg, #FF0527 0%, #C9001B 100%), #FFF41A;
  border-left: 0.5px solid #990015;
  border-top: 0.5px solid #990015;
  border-bottom: 0.5px solid #990015;
  border-right: none;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.35);
  color: white;
  font-size: clamp(12px, 9cqi, 18px);
  font-weight: 700;
  letter-spacing: 0.6px;
  text-align: center;
}
.qIVSIfDOPnIPBG242qWi[data-lang="cjk"] {
  padding: 6px 4px 5px 3px;
}
@media (min-height: 500px) {
  [data-view='single'][data-section='pickRandom'] .qIVSIfDOPnIPBG242qWi {
    top: 38px;
    min-width: 38px;
  }
}
@media (min-width: 1025px) {
  .qIVSIfDOPnIPBG242qWi {
    top: 38px;
    min-width: 38px;
  }
  [data-game-card-size="compact"] .qIVSIfDOPnIPBG242qWi {
    top: 30px;
    min-width: 30px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/NewGameBanner/NewGameBanner.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sEAAsE;EACtE,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,2CAA2C;EAC3C,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;EACA;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".badge {\n  position: absolute;\n  top: 30px;\n  min-width: 30px;\n  right: 0;\n  font-family: 'Futura PT Cond';\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px;\n  line-height: 0.7em;\n  background: linear-gradient(180deg, #FF0527 0%, #C9001B 100%), #FFF41A;\n  border-left: 0.5px solid #990015;\n  border-top: 0.5px solid #990015;\n  border-bottom: 0.5px solid #990015;\n  border-right: none;\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n  box-shadow: 1px 2px 2px rgba(0, 0, 0, 0.35);\n  color: white;\n  font-size: clamp(12px, 9cqi, 18px);\n  font-weight: 700;\n  letter-spacing: 0.6px;\n  text-align: center;\n}\n.badge[data-lang=\"cjk\"] {\n  padding: 6px 4px 5px 3px;\n}\n@media (min-height: 500px) {\n  [data-view='single'][data-section='pickRandom'] .badge {\n    top: 38px;\n    min-width: 38px;\n  }\n}\n@media (min-width: 1025px) {\n  .badge {\n    top: 38px;\n    min-width: 38px;\n  }\n  [data-game-card-size=\"compact\"] .badge {\n    top: 30px;\n    min-width: 30px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `qIVSIfDOPnIPBG242qWi`
};
export default ___CSS_LOADER_EXPORT___;
